const _import = require('../import-' + process.env.NODE_ENV)

const certificateExpiredRouter = [
  {
    path: '/certificateExpired/index',
    name: 'certificateExpiredIndex',
    component: _import('certificateExpired/index'),
    meta: {
      auth: true,
      // keepAlive: true,
      title: '证件管理'
    }
  },
  {
    path: '/certificateExpired/normal',
    name: 'certificateExpiredNormal',
    component: _import('certificateExpired/normal'),
    meta: {
      auth: true,
      // keepAlive: true,
      title: '证件管理'
    }
  },
  {
    path: '/certificateExpired/hidden',
    name: 'certificateExpiredHidden',
    component: _import('certificateExpired/hidden'),
    meta: {
      auth: true,
      // keepAlive: true,
      title: '证件管理'
    }
  },
  {
    path: '/certificateExpired/exceed',
    name: 'certificateExpiredExceed',
    component: _import('certificateExpired/exceed'),
    meta: {
      auth: true,
      // keepAlive: true,
      title: '证件管理'
    }
  }
]
export default certificateExpiredRouter



// WEBPACK FOOTER //
// ./src/router/work/certificateExpired.js